export const CONTACT_DETAILS_ROOT_ROUTE = '/account/contactdetails'

export const routes = {
  home: `${CONTACT_DETAILS_ROOT_ROUTE}`,
  editAddress: `${CONTACT_DETAILS_ROOT_ROUTE}/address/edit/:accountNumber`,
  editContactDetails: `${CONTACT_DETAILS_ROOT_ROUTE}/edit/:accountNumber`,
} as const

export const getEditAddressRoute = (accountNumber = '') =>
  routes.editAddress.replace(':accountNumber', accountNumber)
export const getEditContactDetailsRoute = (accountNumber = '') =>
  routes.editContactDetails.replace(':accountNumber', accountNumber)
